import { render, staticRenderFns } from "./DoctorCases.vue?vue&type=template&id=0cceb242&scoped=true&"
import script from "./DoctorCases.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorCases.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DoctorCases.vue?vue&type=style&index=0&id=0cceb242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cceb242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cceb242')) {
      api.createRecord('0cceb242', component.options)
    } else {
      api.reload('0cceb242', component.options)
    }
    module.hot.accept("./DoctorCases.vue?vue&type=template&id=0cceb242&scoped=true&", function () {
      api.rerender('0cceb242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorCases/DoctorCases.vue"
export default component.exports